import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase, VistaBase } from '@/components/a-interfaz/a-controlador';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import { isNumber } from 'util';
import { Utiles } from '@/__env/pluggins/event-bus';
import router from '@/__env/router.index';

export class ControladorInterfaz extends ControladorBase
{
    constructor()
    {
        super();
        this.Vista.Titulo = 'Ventas';
        this.Vista.Opciones.push(
            { Tipo: 'opcion', Icono: 'view-list', Modo: 'resumen', Titulo: 'Resumen' },
            { Tipo: 'opcion', Icono: 'package', Modo: 'items', Titulo: 'Items' },
            { Tipo: 'opcion', Icono: 'bank', Modo: 'pagos', Titulo: 'Pagos' },
            { Tipo: 'opcion', Icono: 'receipt', Modo: 'facturacion', Titulo: 'Facturación' },
            { Tipo: 'opcion', Icono: 'account', Modo: 'editar_cliente', Titulo: 'Editar cliente' },
            { Tipo: 'opcion', Icono: 'truck', Modo: 'editar_envio', Titulo: 'Editar envío' },
        );
    }

    public Pedido: Pedido = new Pedido();
    async Iniciar( ped: Pedido | number )
    {
        this.Pedido = null;
        this.Vista.Modo = '';
        this.Vista.Estado = 'cargando';
        if ( ped instanceof Pedido )
        {
            this.Pedido = ped;
        } else if ( isNumber( ped ) )
        {
            this.Pedido = await Pedido.create( ped );
        }

        if ( !this.Pedido || !this.Pedido.Existe )
        {
            Utiles.Notificaciones.Error( '¡Pedido no existe!' );
            router.replace( '/pedidos' );
            return;
        }
        await this.Pedido.CargarPagos();
        this.Vista.Titulo = 'Pedido ' + this.Pedido.Id;
        this.Vista.Estado = 'iniciado';
    }

}

export const Controlador = new ControladorInterfaz();

